
import { INameValueFilter } from 'src/app/models/filter';


export class NameValueMapper {
    public map(value: any, nameKey: string, valueKey?: string): INameValueFilter[] | INameValueFilter {
        if (!nameKey || !valueKey) {
            return value;
        }

        let result;

        if (Array.isArray(value)) {
            result = value.map((v) => this.transformToNameValueObject(v, nameKey, valueKey));
        } else if (typeof value === 'object' && value !== null) {
            result = this.transformToNameValueObject(value, nameKey, valueKey);
        } else {
            result = value;
        }
        return result;
    }

    transformToNameValueObject(object: any, nameKey: string, valueKey?: string): INameValueFilter {
        const name = object[nameKey];
        const value = (valueKey) ? object[valueKey] : "";
        return {
            name,
            value
        };
    }
}
